import { ComponentProps, JSX } from "solid-js";
import c from "class-c";

import styles from "./ScrollView.module.scss";

declare namespace ScrollView {
  type Props = ComponentProps<"div"> & {
    direction?: "x" | "y";
    hideScrollbar?: boolean;
    children: JSX.Element;
  };
}

function ScrollView({
  class: className,
  direction = "y",
  hideScrollbar,
  children,
  ...props
}: D<ScrollView.Props>) {
  return (
    <div
      class={c`
        ${styles["scroll-view"]}
        ${styles[`direction:${direction}`]}
        ${hideScrollbar ? styles["hide-scrollbar"] : ""}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
}

declare namespace ScrollView.Reversed {
  type Props = ScrollView.Props;
}

ScrollView.Reversed = Reversed;
function Reversed({
  class: className,
  children,
  ...props
}: D<ScrollView.Reversed.Props>) {
  return (
    <div class={c`${styles["reversed-scroll-view"]} ${className}`} {...props}>
      <div>{children}</div>
    </div>
  );
}

export default ScrollView;
